<template>
  <div class="myaccount">
    <CommonHead></CommonHead>
    <div class="impersonatedetails">
        <div class="container">
            <div class="searchbox">
                <label for="impersonatesearch">Search For Account</label>
                <input id="impersonatesearch" type="text" v-model="form.searchaccount" placeholder="Type here...">
                <b-button type="submit" block variant="dark" @click="searchAccount">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9707 12.3796H13.6291L17.7874 16.5462L16.5457 17.7879L12.3791 13.6296V12.9712L12.1541 12.7379C11.2041 13.5546 9.97074 14.0462 8.62907 14.0462C5.6374 14.0462 3.2124 11.6212 3.2124 8.62956C3.2124 5.63789 5.6374 3.21289 8.62907 3.21289C11.6207 3.21289 14.0457 5.63789 14.0457 8.62956C14.0457 9.97122 13.5541 11.2046 12.7374 12.1546L12.9707 12.3796ZM4.87907 8.62956C4.87907 10.7046 6.55407 12.3796 8.62907 12.3796C10.7041 12.3796 12.3791 10.7046 12.3791 8.62956C12.3791 6.55456 10.7041 4.87956 8.62907 4.87956C6.55407 4.87956 4.87907 6.55456 4.87907 8.62956Z" fill="white"/>
                    </svg>
                    Search
                </b-button>
            </div>
	        <h1 class="text-left" v-if="accounts.length > 0">Results found for {{$route.query.account}}</h1>
            <h1 class="text-left" v-else>No Results found</h1>
            <b-card class="" no-body>
            <div class="tab-content">    
            <div class="card-body">
                <div class="card-content" v-if="accounts.length > 0 && !isLoading">
                    <div class="boxgrid"  v-for="(account, accountind) in accounts" :key="accountind">
                    <div class="samediv">
                        <span>Account Number</span>
                        <p>{{account.accountnumber}}</p>
                    </div>
                    <div class="samediv">
                        <span>Account Name</span>
                        <p>{{account.companyname}}</p>
                    </div>
                    <div class="samediv">
                        <span>First Name</span>
                        <p>{{account.firstname}}</p>
                    </div>
                    <div class="samediv">
                        <span>Last Name</span>
                        <p>{{account.lastname}}</p>
                    </div>
                    <div class="samediv">
                        <span>Email</span>
                        <p>{{account.email}}</p>
                    </div>
                    <div class="samediv">
                        <button @click="loggedMeIn(account.id)" class="btn btn-dark">Select Account</button>
                    </div>
                    </div>
                </div>
                <SKLoader :repeat="4" :loading="isLoading" speed="1s" class="impersonateloadercont">
                    <SkImpersonate />
                </SKLoader>
                <div class="accountdetails">
                    <div class="propagination" v-if="accounts.length > 0">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SkImpersonate from "@/views/skeletons/SkImpersonate";
export default {
  components: {
    CommonHead,
    CommonFoot,
    Loading,
    SkImpersonate
  },
  mixins: [ResourceMixin],
  mounted() {
      this.form.searchaccount = this.$route.query.account;
      this.loadAccounts();
  },
  data() {
    return {
      accounts:{},
      rows: 10,
      perPage: 10,
      currentPage: 1,
      form:{
          searchaccount:"",
          page:1
      },
      isLoading: false,
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ]
    };
  },
  methods: {
    paginationChange(page){
        this.form.page = page;
        this.loadAccounts();
    },
    loadAccounts(){
      this.isLoading = true;
      this.$store.dispatch("loadImpersonateAccount",{form:this.form}).then(accounts => {
          this.rows = accounts.data.total;
          this.currentPage = this.form.page;
          this.accounts = accounts.data.accounts;
          this.isLoading = false;
      });
    },
    searchAccount(){
        this.$router.push("/shop/impersonate-account?account="+this.form.searchaccount);
        this.loadAccounts();
    },
    loggedMeIn(user_id){
        this.$store.dispatch("loadImpersonateAccountLogin",user_id).then(rs => {
            // this.$router.push("/shop/account");
            window.location = "/shop/account";
        });
    }
  }
};
</script>
<style>
.impersonatedetails{
    background: #ECECEC;
}
.impersonatedetails h1{
    padding-bottom: 40px;
}
.impersonatedetails .searchbox{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
    gap: 24px;
}
.impersonatedetails .searchbox label{
    font-size: 16px;
    font-weight: 600;
    white-space: pre;
}
.impersonatedetails .searchbox input[type="text"]{
    height: 45px;
    padding: 0px 16px;
    border-radius: 5px;
    border: 1px solid #D2D2D2;
    background: #FFF;
    font-size: 12px;
    font-weight: 400;
    width: 100%;
}
.impersonatedetails .searchbox button{
    display: flex;
    height: 45px;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: auto;
    margin: 0;
}
.impersonatedetails .searchbox button:hover svg path{
    fill: #303030;
}
.impersonatedetails .card{
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
}
.impersonatedetails .card-body{
    padding: 0;
}
.impersonatedetails .card-content{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    column-gap: 40px;
}
.impersonatedetails .boxgrid {
    width: calc(50% - 40px);
    padding: 24px;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    margin-right: 0;
    margin-bottom: 40px;
    position: relative;
    background: #fff;
}
.impersonatedetails .boxgrid .samediv{
    display: flex;
    align-items: center;
    justify-content: left;
    margin-bottom: 16px;
}
.impersonatedetails .boxgrid .samediv span{
    flex-basis: 50%;
    font-size: 14px;
    font-weight: 500;
    color: #777;
}
.impersonatedetails .boxgrid .samediv p{
    flex-basis: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #303030;
}
.impersonatedetails .boxgrid .samediv button{
    height: 38px;
    border-radius: 5px !important;
    font-size: 12px;
    font-weight: 600;
    line-height: 38px;
    margin: 0;
    padding: 0px 16px;
}
.impersonatedetails .propagination{
    width: 100%;
    margin-bottom: 40px;
}
.impersonatedetails .propagination .page-item .page-link{
    background: transparent;
}
@media only screen and (max-width:767px) {
    header .inner_header .search-account .accountcart .impersonatesec{
        display: none;
    }
    .impersonatedetails .boxgrid{
        width: 100%;
    }
    .impersonatedetails .searchbox{
        flex-direction: column;
        align-items: start;
        gap: 20px;
    }
}
</style>